module.exports = __webpack_public_path__ + "img/W-27.ab5c0c9a.jpg";